module.exports = __webpack_public_path__ + "static/03-b3134d487f63b9d1c78cf507e0a805cc.jpg";